export default "__VITE_ASSET__BBJNyvf9__"